/*
 * Copyright Mimic Networks, Inc. 2025.
 */

/* eslint-disable react/prop-types */
import { SettingOutlined } from '@ant-design/icons';
import React from 'react';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Text } from '@/primitives/Text';

import {
  blueBadgeStyle,
  engineHeaderStyle,
  engineItemStyle,
  engineNameStyle,
  enginesListStyle,
  sectionCardStyle,
  sectionHeaderStyle,
  sectionIconStyle,
  sectionTitleStyle,
} from './utils/styles';
import { Engine } from './utils/types';

interface EnginesSectionProps {
  engines: Engine[];
}

export const EnginesSection = React.memo<EnginesSectionProps>(({ engines }) => {
  const { t } = useMimicTranslation('configPrettyViewer');

  return (
    <div style={sectionCardStyle}>
      <div style={sectionHeaderStyle}>
        <SettingOutlined style={sectionIconStyle} />
        <Text style={sectionTitleStyle}>{t('engines.title')}</Text>
        <span style={blueBadgeStyle}>{t('engines.configured', { count: engines.length })}</span>
      </div>

      <div style={enginesListStyle}>
        {engines.map((engine) => (
          <div key={engine.name} style={engineItemStyle}>
            <div style={engineHeaderStyle}>
              <Text style={engineNameStyle}>{engine.name}</Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
